import React from 'react';

class Loading extends React.Component {
  render() {
    return (
      <div className="col-sm-12 loader">
        <p className="text-center">
          <i className="fa fa-exclamation-triangle fa-3x fa-fw" />
          <span className="sr-only">Error Loading Page.</span>
        </p>
      </div>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// src/components/Error/Error.js